import User from '@/models/User'

const state = {
  user: User.from(localStorage.token),
  redirectPath: null
}

const getters = {
  currentUser (state) {
    return state.user
  },
  redirectPath (state) {
    return state.redirectPath
  }
}

const mutations = {
  login (state) {
    state.user = User.from(localStorage.token)
  },
  logout (state) {
    state.user = null
    localStorage.removeItem('token')
  },
  redirectToPath (state, redirectPath) {
    state.redirectPath = redirectPath
  }
}

export default {
  state,
  getters,
  mutations
}
